import F84Game from "../Game";
import ARIA from "../utils/ARIA";
import Scene from "./Scene";

export default class ResizableScene extends Scene {
	protected _viewport: Phaser.GameObjects.Zone;
	public get viewport(): Phaser.GameObjects.Zone {
		return this._viewport;
	}

	private _sceneEvents: Phaser.Events.EventEmitter;

	private static SHUTDOWN = "shutdown";

	init(..._args: any[]): void {
		this._sceneEvents = new Phaser.Events.EventEmitter();
		this.scale.on(Phaser.Scale.Events.RESIZE, this.resize, this);
		this.resize();
	}

	create(): void {
		this.game.events.emit(Phaser.Scenes.Events.CREATE, this);
		this.events.on(Phaser.Scenes.Events.SHUTDOWN, this.shutdown, this);
		ARIA.showLayer();
	}

	onShutdown(fn: () => void, context?: CallbackContext): void {
		this._sceneEvents.addListener(ResizableScene.SHUTDOWN, fn, context);
	}

	shutdown(): void {
		this._sceneEvents.emit(ResizableScene.SHUTDOWN);

		this.scale.off(Phaser.Scale.Events.RESIZE, this.resize, this);
		this.events.off(Phaser.Scenes.Events.SHUTDOWN, this.shutdown, this);

		this._sceneEvents.destroy();
		this._sceneEvents = null;
	}

	getState(): any {
		return null;
	}

	resize(): void {
		this.cameras.cameras.forEach((camera) => {
			const zoom = Math.min(this.scale.zoom * F84Game.Instance.DevicePixelRatio, 1);
			camera.setZoom(zoom);
			camera.width = this.scale.gameSize.width;
			camera.height = this.scale.gameSize.height;
			camera.setOrigin(0, 0);
		});
		if (this._viewport != null) {
			this._viewport.destroy();
		}
		this._viewport = this.add.zone(
			this.scale.gameSize.width / 2,
			this.scale.gameSize.height / 2,
			this.scale.gameSize.width,
			this.scale.gameSize.height
		);
		ARIA.resize(this);
	}
}
